import * as common from './common.json';

export const it = {
  common,
};
